import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export enum CancellationReasonFoundBetterAlternativeOption {
  LearnMore = 'learnMore',
  CancelAnyway = 'cancelAnyway'
}

export function getCancellationReasonFoundBetterAlternativeStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.CancellationReasonFoundBetterAlternative,
    type: 'single-select',
    wordings: {
      title: t(`${ManageSubscriptionStepId.CancellationReasonFoundBetterAlternative}.${title}`)
    },
    options: [
      {
        id: CancellationReasonFoundBetterAlternativeOption.LearnMore,
        label: t(`${ManageSubscriptionStepId.CancellationReasonFoundBetterAlternative}.${options}.${CancellationReasonFoundBetterAlternativeOption.LearnMore}`)
      },
      {
        id: CancellationReasonFoundBetterAlternativeOption.CancelAnyway,
        label: t(`${ManageSubscriptionStepId.CancellationReasonFoundBetterAlternative}.${options}.${CancellationReasonFoundBetterAlternativeOption.CancelAnyway}`)
      }
    ]
  }
}
